import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'ServiceRegistAttributeGroupModal',
  components: {
    Loading
  },
  data () {
    return {
      processing: false,
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      active: state => state.serviceRegistAttributeGroupModal.active,

      // model
      values: state => state.serviceRegistAttributeGroupModal.values,

      // form
      serviceId: state => state.serviceRegistAttributeGroupModal.serviceId,
      attributeTypeId: state => state.serviceRegistAttributeGroupModal.attributeTypeId,
      attributeGroupId: state => state.serviceRegistAttributeGroupModal.targetId,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),

    // result
    resultId () {
      return this.values.attributeGroupUuid
    },
    resultName () {
      return this.values.attributeGroupName
    },
    showLocationNickname() {
      return this.values.locationNickname || "未設定"
    },
    resultLocationNickname() {
      return this.values.locationNickname
    },

    // input
    inpCode: {
      get () {
        return this.values.inpCode
      },
      set (value) {
        this.setInputValue({
          key: 'inpCode',
          value: value
        })
      }
    },
    inpMailAddress: {
      get () {
        return this.values.inpMailAddress
      },
      set (value) {
        this.setInputValue({
          key: 'inpMailAddress',
          value: value
        })
      }
    },
    inpDeviceSerial: {
      get() {
        return this.values.inpDeviceSerial;
      },
      set(value) {
        this.setInputValue({
          key: "inpDeviceSerial",
          value: value
        });
      }
    },

    // validate
    inpCodeIsValid () {
      return Validator.validText(this.inpCode)
    },
    formIsValid () {
      return this.inpCodeIsValid
    },
    disableConfirmButton () {
      if (!this.formIsValid) return true
      if (
        this.values.attributeGroupCode === this.inpCode &&
        this.values.attributeGroupMailAddress ===
          (this.inpMailAddress ? this.inpMailAddress : null) &&
        this.values.notifyToDevice.deviceSerialNo ===
          (this.values.inpDeviceSerial ? this.values.inpDeviceSerial : null)
      )
        return true
      return false
    },
    disableSearchButton() {
      return this.inpDeviceSerial === null || this.inpDeviceSerial === "";
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    },
    confirmAccepted: function (to) {
      // 登録
      if (this.confirmKey === 'submit') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      hide: 'serviceRegistAttributeGroupModal/hide',
      setUpdated: 'serviceRegistAttributeGroupModal/setUpdated'
    }),
    ...mapMutations({
      setInputValue: 'serviceRegistAttributeGroupModal/setInputValue',
    }),

    init () {

    },

    confirmData () {
      if (!this.formIsValid) return
      this.showConfirm({
        key: 'submit',
        title: '',
        body: 'この内容で属性を変更しますか？',
        acceptLabel: '変更'
      })
    },
    postData () {
      this.processing = true

      let parameters = {
        serviceUuid: this.serviceId,
        attributeTypeUuid: this.attributeTypeId,
        attributeGroupUuid: this.attributeGroupId,
        request: {
          attributeGroupCode: this.inpCode,
          attributeGroupMailAddress: this.inpMailAddress,
          notifyToDeviceSerial: this.values.inpDeviceSerial
            ? this.values.inpDeviceSerial
            : null
        }
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceAttributeType'],
        ['v1ServiceAttributeGroupPut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: '属性の変更',
              body: '「属性」を変更しました。'
            })
            
            // データ更新フラグを有効
            // 呼び出し元のページで一覧を更新するため
            this.setUpdated(true)

            this.closeModal()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    searchLocation() {
      this.processing = true;
      let parameters = {
        deviceSerial: this.inpDeviceSerial,
        filters: {
          serviceUuid: this.serviceId
        }
      };
      ApiManager.request(["community"], ["v1LocationNicknameGet"], [parameters])
        .then(res => {
          this.processing = false;
          let status = Utility.parseResponse(res);
          if (status.result) {
            this.values.locationNickname = res[0].data.nickName;
          } else if (status.error) {
            this.showError(res);
          } else {
            this.showError(null);
          }
        })
        .catch(error => {
          this.processing = false;
          this.showError(null);
        });
    },
    initDeviceSerial() {
      this.values.locationNickname = ""
      this.values.inpDeviceSerial = null
    },

    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}